<template>
    <section id="organizations" class="organizations">
        <swiper :options="swiperOption">
            <swiper-slide class="swiper-slide" v-for="org in organizations">
                <div class="item">
                    <div class="img" v-bind:style="{'background-image':'url(' + org.imagePath +')'}"></div>
                </div>
            </swiper-slide>
        </swiper>
    </section>
</template>
<script>
    export default {
        data()
        {
            return {
                screenWidth: null,
                organizations: [],
                swiperOption: {
                    loop: true,
                    grabCursor: true,
                    freeMode:true,
                    autoplay: {
                        delay: 3000,
                    },
                    slidesPerView: 'auto',
                    spaceBetween: 8
                }
            };
        },

        beforeMount()
        {
            this.screenWidth = window.outerWidth;

            for (var i = 1; i < 24; i++)
                this.organizations.push({ imagePath: require('../../assets/image/organizations/' + i + '.png') })
        }
    };
</script>
<style scoped>
    .organizations {
        width: 100%;
        padding:20px 0;
        height: 150px;
        float: right;
        background: #fff;
    }

        .organizations .swiper-slide {
            width: 100px;
        }

        .organizations .item {
            width: 100px;
            height: 100px;
            border-radius: 100%;
            border: #ddd solid 1px;
            background: #fff;
            text-align: center;
            padding-top: 20px;
        }

            .organizations .item .img {
                filter: grayscale(100%);
                background-position: center center;
                background-size: cover;
                width: 60px;
                height: 60px;
                margin: 0 auto;
            }

            .organizations .item:hover .img {
                filter: unset;
            }
</style>
